<template>
    <section class="view">
        <ViewHeader>
            <template slot="title">{{ $t('pages.choose_product.page_title') }}</template>
            <div slot="intro" v-html="$t('pages.choose_product.page_subtitle')"></div>
        </ViewHeader>

        <div class="container mt-3" v-if="doesCartExist && !canAddPrintItems">
            <b-alert :show="true" dismissible variant="light">
                <h3 class="font-weight-bold"> {{ $t('pages.choose_product.alert_disabled_title') }} </h3>
                <h5 class="text-secondary" v-html="$t('pages.choose_product.alert_disabled_text')"> </h5>
            </b-alert>
        </div>

        <div class="container view-body view-body--padded _section-content-page">
            <PrintProductsList />
        </div>
    </section>
</template>


<script>
    import { mapGetters } from "vuex";
    import ViewHeader from '@/components/ViewHeader'
    import PrintProductsList from '@/components/PrintProductsList.vue'

    export default {
        // name: 'print-products',
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
                let isEdit = to.params.printItemId !== undefined
                console.log('to.params.printItemId', isEdit)
                // access to component instance via `vm`
                console.log('vm isProductSelected?', vm.$store.getters['prints/isProductSelected'])
            })
        },

        components: {
            ViewHeader,
            PrintProductsList
        },

        computed: {
            ...mapGetters('cart', [
                'doesCartExist',
                'canAddPrintItems'
            ])
        }
    }
</script>
